import React, { Component } from 'react'
import HTML5Backend, { NativeTypes } from 'react-dnd-html5-backend'
import { DndProvider } from 'react-dnd'
import Quill from 'quill'
import QuillCursors from 'quill-cursors'
import { Droppable } from '@components/UI'

import Upload from '../Upload'
import Clipboard from './Clipboard'

Quill.register('modules/clipboard', Clipboard, true)
Quill.register('modules/cursors', QuillCursors)

class Editor extends Component {
  componentDidMount() {
    this.editor = new Quill('#note-container', {
      modules: {
        toolbar: {
          container: '#note-toolbar'
        },
        history: {
          userOnly: true
        },
        cursors: true
      }
    })

    if (this.props.init) this.props.init(this.editor)
    if (this.props.active) this.props.loadFile(this.props.active)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.active !== this.props.active && this.props.active) {
      this.editor.getModule('cursors').clearCursors()
      this.props.loadFile(this.props.active)
    }
  }

  onDrop = (item, monitor) => {
    if (monitor) {
      const [file] = monitor.getItem().files
      this.props.upload(file)
    }
  }

  render() {
    return (
      <DndProvider backend={HTML5Backend}>
        <Droppable
          ref={(elem) => (this.dropzone = elem)}
          item={{ type: NativeTypes.FILE }}
          onDrop={this.onDrop}
          style={{ width: '100%', height: '100%' }}
        >
          {(isOver) => {
            return (
              <React.Fragment>
                <div className='editor-wrapper' onClick={this.props.focus}>
                  <div
                    id='note-container'
                    onBlur={this.props.onBlur}
                    onFocus={this.props.onFocus}
                  />
                </div>
                {isOver && <Upload />}
              </React.Fragment>
            )
          }}
        </Droppable>
      </DndProvider>
    )
  }
}
export default Editor
